import axios from 'axios';

export async function setFive9BusinessHours() {
  const response = await axios.get('/five9');
  if (response) {
    window.sessionStorage.setItem('five9', JSON.stringify(response.data.businessHours));
  }
  return response;
}

export async function checkFive9Availibility() {
  const response = await axios.get('/five9');
  if (response) {
    return response.data.businessHours.openForBusiness;
  }
}
